import React, { FC } from 'react';
import { Coral, Container, Content, Description, VacancyButton } from './styled';
import { BaseWrapper } from 'styles/common';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { CareerVacancyLink } from 'consts/header-menu';
import { css } from 'styled-components';
import { mediaSm } from 'theme/theme-helper-selectors';
import ParallaxImage from 'components/parallax/Parallax';

interface IProps {
    description: string;
    isClosed: boolean;
}

export const CareerPortal: FC<IProps> = ({ description, isClosed }) => {
    const { t } = useTranslation('pages/home');
    return (
        <Container id="career_link">
            <BaseWrapper>
                <Content>
                    {isClosed && (
                        <ParallaxImage
                            src={process.env.PUBLIC_URL + '/assets/images/bell.png'}
                            alt="Bell"
                            speed={0.15}
                            smSpeed={0}
                            customStyles={css`
                                position: absolute;
                                right: -300px;
                                top: -150px;
                                z-index: 25;

                                @media (${mediaSm}) {
                                    width: 230px;
                                    right: auto;
                                    left: 0;
                                    top: -55px;
                                }
                            `}
                        />
                    )}
                    <Coral src={process.env.PUBLIC_URL + '/assets/images/coral.png'} />
                    <Description dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
                    <VacancyButton as={'a'} href={CareerVacancyLink} target="_blank" type="button">
                        {t('to-vacancy')}
                    </VacancyButton>
                </Content>
            </BaseWrapper>
        </Container>
    );
};
